import { render } from "./MatchedReports.vue?vue&type=template&id=35f8b502&scoped=true"
import script from "./MatchedReports.vue?vue&type=script&lang=js"
export * from "./MatchedReports.vue?vue&type=script&lang=js"

import "./MatchedReports.vue?vue&type=style&index=0&id=35f8b502&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f8b502"]])

export default __exports__